import { render, staticRenderFns } from "./HelpText.vue?vue&type=template&id=1b0c7f40&"
import script from "./HelpText.vue?vue&type=script&lang=ts&"
export * from "./HelpText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports